import { isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import LightArrow from "../../../core/assets/oot/gshd/light-arrows_32x32.png";
import Item from "../../../core/items/Item";
import OotItem, { DbItemProps } from "./OotItem";
import { updateOotItem } from "./OotItemHelper";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";

let id = "OoT_LightArrow"

const LightArrowItem = () => {



    let dispatch = useDispatch();
    let isGoMode = useSelector((state: AppState) => state.ui.ootr.main.items.some(x => x.id === "Go Mode" && x.isObtained))
    let LA = useSelector((state: AppState) => state.ui.ootr.main.items.find(x => x.id === id))


    if (isGoMode && !LA?.isObtained && !isNil(LA)) {
        return <img style={{zIndex: 9999999}} src={require("../../../core/assets/oot/classic/LaGlowMode.gif")} alt="dzad" width="30px" height={"30px"} onClick={() => {
            updateOotItem({ id: id, title: "Light Arrow", state: 0, isChecked: false, isObtained: true }, dispatch)
        }} />
    }

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={LightArrow} title="Light Arrow" updateItem={updateOotItem} item={item} isMajor
            />
        }}</OotItem>
}

export default LightArrowItem;


export const SimpleLightArrowItem  = (props: SimpleItemProps) => {


    return <StaticItem
        image={LightArrow}
        onClick={props.onClick}
        name={id}
    />


}

export const DbLightArrowItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultLightArrowItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={LightArrow}
        id={id}
        title={id}
        isObtained={item.isObtained}
    />


}

const DefaultLightArrowItem : ItemLightDto = {
    img: LightArrow,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}